<template>
<div id="home">

  <vue-headful
    title="Designbox - Home"
    description="Designbox"
/>

  <section class="section warning" style="background-color:#ffa500;" v-show="getLoginPossibleText.length > 0">
    <div class="container">
        <div class="columns">
            <div class="column">
              <p v-html="getLoginPossibleText"></p>
            </div>
        </div>
    </div>
  </section>
  <section class="hero" v-if="getLoginPossible">
    <div class="hero-body">
      <LoginBox :redirect="working" />
    </div>
  </section>
  <section class="section info">
    <div class="container">
      <div class="has-text-centered">
        <a id="info"><h1>{{ $t("info") }}</h1></a>
      </div>
      <div class="columns has-text-centered">
        <div class="column" style="white-space:pre-line;">
          {{ $t("info-detail") }}
        </div>
      </div>
    </div>
  </section>
  <section class="section contact">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="contact-container">
            <div class="columns">
              <div class="column has-text-centered">
                <a id="kontakt"><h1>{{ $t("contact") }}</h1></a>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6">
                <h2>{{ $t("there-for-you-title") }}</h2>
                <p>{{ $t("there-for-you") }}</p>
              </div>
              <div class="column is-6">
                <p><a href="mailto: office@tzaustria.at">office@tzaustria.at</a></p>
                <p><a href="tel: +43 2538/8628 – 0">+43 2538/8628 – 0</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>

import HomeBase from '@/components/HomeBase';
import LoginBox from './LoginBox';

export default {
    name:'Home',
    extends: HomeBase,
    components: { LoginBox },
    mounted () {
        const ua   = window.navigator.userAgent
        const msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            this.$router.push ({ name : "use-other-browser"})
        }
    }
}
</script>

<style>

.about{
  background-color: #057989;
  padding-top:80px;
  padding-bottom:80px;
  color:#fff!important;
}

.hero-title{
    font-weight:bold;
    font-size:50px;
}
.hero{
    background-image:url(./assets/img/kitchen.jpg);
    background-position: center center;
    background-repeat:  no-repeat;
    background-size:  inherit;
    background-color: #999;
}

.contact{
    background-image:url(./assets/img/contact.jpg);
    background-position: center center;
    background-repeat:  no-repeat;
    background-size:  inherit;
    background-color: #999;
}

.contact-container{
  background-color:#fff;
  padding-left:35px;
  padding-right:35px;
  padding-top:35px;
  padding-bottom: 35px;
}

.showcase{
  margin-top:55px;
  margin-bottom:55px;
}

.box{
  background: rgba(255,255,255,0.9);
padding: 30px;
-webkit-box-shadow: 0 1px 2px rgba(0,0,0,0.15);
-moz-box-shadow: 0 1px 2px rgba(0,0,0,0.15);
box-shadow: 0 1px 2px rgba(0,0,0,0.15);
-webkit-border-radius: 5px;
-moz-border-radius: 5px;
-ms-border-radius: 5px;
-o-border-radius: 5px;
border-radius: 5px;
}
</style>
